import { render, staticRenderFns } from "./logEditDialog.vue?vue&type=template&id=320f628f&scoped=true"
import script from "./logEditDialog.vue?vue&type=script&lang=js"
export * from "./logEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f628f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320f628f')) {
      api.createRecord('320f628f', component.options)
    } else {
      api.reload('320f628f', component.options)
    }
    module.hot.accept("./logEditDialog.vue?vue&type=template&id=320f628f&scoped=true", function () {
      api.rerender('320f628f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clientManagement/logEditDialog.vue"
export default component.exports